import clsx from 'clsx';
import React from 'react';

interface TagSelectProps {
  tags: Array<[string, string]>;
  selected: Array<{ value: string }>;
  onClick: (tag: string, selected: boolean) => void;
}

export const TagSelect = (props: TagSelectProps) => {
  return (
    <div className="flex flex-wrap">
      {props.tags.map(([key, label]) => {
        const selected = props.selected.find(v => v.value === key);
        return (
          <div
            key={key}
            className="group relative mr-2 mt-2 cursor-pointer rounded bg-white px-2 py-0.5 text-sm shadow hover:shadow-lg"
            onClick={() => props.onClick(key, !!selected)}
          >
            <div
              className={clsx(
                'absolute -inset-px rounded border-2 border-transparent [background:linear-gradient(var(--quick-links-hover-bg,theme(colors.sky.50)),var(--quick-links-hover-bg,theme(colors.sky.50)))_padding-box,linear-gradient(to_top,theme(colors.indigo.400),theme(colors.cyan.400),theme(colors.sky.500))_border-box] group-hover:opacity-100',
                selected ? '' : 'opacity-0'
              )}
            />
            <span className="relative">{label}</span>
          </div>
        );
      })}
    </div>
  );
};
